import React from "react";
import {Form, Input , Radio} from 'antd';
import NHFormItem from '../common/NHFormItem';
const { TextArea } = Input;

/**
 * 学校信息编辑表单
 * @author yizhiqiang
 * @Email yizhiqiang@ly-sky.com
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {

        const {form,editData} = this.props;

        return (
            <Form>
                <NHFormItem id={'bt'} label={"标题"} form={form} required={true} initialValue={editData?editData.bt:undefined}>
                    <Input />
                </NHFormItem>
                <NHFormItem id={'ip'} label={"IP地址"} form={form} required={true} initialValue={editData?editData.ip:undefined}>
                    <Input />
                </NHFormItem>
                <NHFormItem id={'dk'} label={"端口"} form={form} required={true} initialValue={editData?editData.dk:undefined}>
                    <Input />
                </NHFormItem>
                <NHFormItem id={'yh'} label={"用户名"} form={form} required={true} initialValue={editData?editData.yh:undefined}>
                    <Input />
                </NHFormItem>
                <NHFormItem id={'mm'} label={"密码"} form={form} required={true} initialValue={editData?editData.mm:undefined}>
                    <Input type={'password'}/>
                </NHFormItem>
                <NHFormItem id={'ms'} label={"描述"} form={form} required={false} initialValue={editData?editData.ms:undefined}>
                    <TextArea style={{height:'80px'}} />
                </NHFormItem>
            </Form>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/face/EditForm.js